export enum StripeStatusEnum {
  incomplete = 'incomplete',
  canceled = 'canceled',
  active = 'active',
  trialing = 'trialing',
  pastDue = 'past_due',
}
